<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.communicationParameters.title.1'"></h2>
        <p>{{labelKeyOrLoremIpsum('study.communicationParameters.paragraph.1') | translate}}</p>
    </section>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.communicationParameters.title.2'"></h2>
        <kiwi-spacer [size]="8"></kiwi-spacer>
        <p>{{labelKeyOrLoremIpsum('study.communicationParameters.paragraph.2') | translate}}
            {{labelKeyOrLoremIpsum('study.communicationParameters.paragraph.3') | translate}}</p>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p class="subtitle"[i18nKey]="'study.communicationParameters.paragraph.4'"></p>

        <table>
            <thead>
            <tr class="_titlePartTable">
                <th>
                </th>
                <th class="_numberColumn">
                    {{study.standardAdvertisementBudget / 2 | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </th>
                <th class="_numberColumn">
                    {{study.standardAdvertisementBudget | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </th>
                <th class="_numberColumn">
                    {{study.standardAdvertisementBudget / 0.6 | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </th>
            <th class="_numberColumn">
                {{study.standardAdvertisementBudget * 5 | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </th>
        </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'study.communicationParameters.budget.note'"></td>
                <td class="_number">0</td>
                <td class="_number">50</td>
                <td class="_number">70</td>
                <td class="_number">90</td>
            </tr>
            </tbody>
        </table>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p>{{labelKeyOrLoremIpsum('study.communicationParameters.paragraph.5') | translate}}</p>
    </section>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.communicationParameters.title.3'"></h2>
        <p>{{labelKeyOrLoremIpsum('study.communicationParameters.paragraph.6') | translate}}</p>

        <kiwi-spacer [size]="16"></kiwi-spacer>
        <table>
            <thead>
            <tr class="_titlePartTable">
                <th></th>
                <th class="_numberColumn" *ngFor="let axis of study.communicationAxes | keyvalue">
                    {{'axis.' + axis.key | translate}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'study.communicationParameters.axis.standing'"></td>
                <td class="_number" *ngFor="let axis of study.communicationAxes | keyvalue">
                    {{axis.value}}
                </td>
            </tr>
            </tbody>
        </table>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p>{{labelKeyOrLoremIpsum('study.communicationParameters.paragraph.7') | translate}}</p>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <table>
            <thead>
            <tr class="_titlePartTable">
                <th></th>
                <th class="_numberColumn"[i18nKey]="'study.communicationParameters.axis.first'"></th>
                <th class="_numberColumn"[i18nKey]="'study.communicationParameters.axis.second'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'study.communicationParameters.axis.weight'"></td>
                <td class="_number">
                    {{study.mainCommunicationAxisWeight}}
                </td>
                <td class="_number">
                    {{study.secondaryCommunicationAxisWeight}}
                </td>
            </tr>
            </tbody>
        </table>
    </section>
</div>


